import React from 'react';
import { useEffect } from 'react';
import api from '../../utils/api';
import { useHistory } from "react-router-dom";
import Cookies from 'universal-cookie';

export default function LogoutContainer(props) {
  const history = useHistory();
  const cookies = new Cookies();
  useEffect(() => {
    api.logout ().then(({data}) => {
        console.log(data)
        localStorage.clear();
        cookies.remove('sso_key', { path: '/', domain: '.deasra.in'});
        cookies.remove('token', { path: '/', domain: '.deasra.in'});
        cookies.remove('sso_key_wp', { path: '/', domain: '.deasra.in'});
        cookies.remove('IsUserAuthenticated', { path: '/', domain: '.deasra.in'});
        history.push('/login');
    }).catch(err=>{
      // console.log(err, ">>>err");
      history.push('/login');
    })
  },[]);
  
  return(
    <div>
    </div>
  )
}